/* Run on homepage only Gurman - Package Protection script -P1 */
document.addEventListener('DOMContentLoaded', function () {
  const protectionVariantId = 52110598242604;
  const drawerTriggerSelector = '#cart-icon-bubble'; // your cart icon trigger
  const maxAttempts = 4;
  const attemptInterval = 400; // ms

  // Helper: fetch current cart JSON
  const fetchCart = () => fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());

  // Helper: remove variant via update.js (works across themes)
  const removeProtectionServer = () =>
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: { [protectionVariantId]: 0 } })
    })
      .then(res => {
        if (!res.ok) throw new Error('update failed: ' + res.status);
        return res.json ? res.json() : Promise.resolve();
      })
      .catch(err => {
        console.warn('removeProtectionServer error', err);
        throw err;
      });

  // Helper: update cart count elements (tries several common selectors)
  const updateCartCountUI = (count) => {
    const selectors = [
      '[data-cart-count]',                 // custom attribute
      '.cart-count',                       // generic
      '.header__cart-count',               // some headers
      '.cart-count-bubble',                // some themes
      '#CartIcon .count',                  // common ID pattern
      '#cart-icon-bubble .count',          // your icon bubble
      '#Cart-Count',                       // fallback
    ];
    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        el.textContent = count;
        // for accessibility, set aria-label or aria-hidden if needed
        if (el.getAttribute('aria-hidden') === 'true') return;
        el.setAttribute('aria-label', `${count} items in cart`);
      });
    });
  };

  // Helper: remove any DOM rows in the drawer/main cart that represent the protection variant
  const removeProtectionFromDOM = (variantId) => {
    // inputs with data-quantity-variant-id
    document.querySelectorAll(`[data-quantity-variant-id="${variantId}"]`).forEach(input => {
      // find nearest row/tr and remove it
      const row = input.closest('tr.cart-item') || input.closest('[data-cart-item]') || input.closest('li');
      if (row) row.remove();
    });

    // other possible data attributes / data-variant-id on remove buttons
    document.querySelectorAll(`[data-variant-id="${variantId}"]`).forEach(el => {
      const row = el.closest('tr.cart-item') || el.closest('li');
      if (row) row.remove();
    });

    // Also try to remove by text matching in case markup is different
    document.querySelectorAll('.cart-item__details, .cart-item').forEach(el => {
      if (el.innerText && el.innerText.includes(String(protectionVariantId))) {
        const row = el.closest('tr.cart-item') || el.closest('li');
        if (row) row.remove();
      }
    });
  };

  // Attempt to remove protection and update UI; returns a Promise that resolves true if removed or not present
  const attemptRemoveProtection = async (attempt = 1) => {
    try {
      const cart = await fetchCart();
      const exists = cart.items.some(i => Number(i.variant_id) === Number(protectionVariantId));
      if (!exists) {
        // ensure UI reflects current cart
        updateCartCountUI(cart.item_count || cart.item_count === 0 ? cart.item_count : '');
        removeProtectionFromDOM(protectionVariantId);
        console.log('[cleanup] protection not present - UI updated');
        return true;
      }

      // If exists, remove server-side
      await removeProtectionServer();

      // After update, fetch fresh cart and update UI
      const freshCart = await fetchCart();
      updateCartCountUI(freshCart.item_count || 0);
      removeProtectionFromDOM(protectionVariantId);
      console.log('[cleanup] protection removed and UI updated');
      return true;
    } catch (err) {
      console.warn(`[cleanup] attempt ${attempt} failed`, err);
      if (attempt < maxAttempts) {
        // exponential backoff-ish
        await new Promise(res => setTimeout(res, attemptInterval * attempt));
        return attemptRemoveProtection(attempt + 1);
      }
      console.error('[cleanup] failed to reliably remove protection after retries');
      return false;
    }
  };

  // Run immediately on load (but do not block rendering)
  attemptRemoveProtection();

  // Also run again when cart icon is clicked (user likely opening drawer)
  const drawerTrigger = document.querySelector(drawerTriggerSelector);
  if (drawerTrigger) {
    drawerTrigger.addEventListener('click', function () {
      // small delay to allow any theme scripts to render drawer items first
      setTimeout(() => attemptRemoveProtection(), 150);
    });
  }

  // Optional: observe DOM changes in case some script re-injects the protection item into the drawer
  // This watches for added nodes in the drawer content area and tries to remove the protection instantly.
  const drawerContainer = document.querySelector('#CartDrawer-CartItems') || document.querySelector('#CartDrawer');
  if (drawerContainer && window.MutationObserver) {
    const mo = new MutationObserver(muts => {
      for (const m of muts) {
        if (m.addedNodes && m.addedNodes.length) {
          // run cleanup quickly (non-blocking)
          attemptRemoveProtection();
          break;
        }
      }
    });
    mo.observe(drawerContainer, { childList: true, subtree: true });
  }
});
/* Gurman's Package Protection script code ends here */